/* eslint-disable react/no-danger */
import React, { useContext, memo } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { AppContext } from '@prisjakt/ui-app-context';
import Button from '@prisjakt/ui-button';
import { bemGenerator } from '@prisjakt/ui-base';

import Modal from '../modal';

import actions from '../../areas/account/actions';

import '../../areas/account/sagas/terms';

import './index.scss';

const styles = bemGenerator('toc-modal', ['error-info']);

const TocModal = ({ acceptPolicyError, items, acceptTermsRequest }) => {
  const { t } = useContext(AppContext);
  return (
    <Modal isOpen shouldShowCloseIcon={false}>
      <div>
        <div className={styles.block}>
          {items.map(item => (
            <div key={item.policyId}>
              <h2>{item.title}</h2>
              <div dangerouslySetInnerHTML={{ __html: item.text }} />
            </div>
          ))}
        </div>
        {acceptPolicyError && (
          <p className={styles['error-info']}>{t('errors', 'error.unknown')}</p>
        )}
        <Button
          onClick={() => {
            acceptTermsRequest(items.map(({ policyType }) => policyType));
          }}
        >
          OK
        </Button>
      </div>
    </Modal>
  );
};

const { arrayOf, shape, bool, string, func, number } = PropTypes;

TocModal.propTypes = {
  items: arrayOf(
    shape({
      policyId: number.isRequired,
      title: string.isRequired,
      text: string.isRequired,
    })
  ).isRequired,
  acceptTermsRequest: func,
  acceptPolicyError: bool,
};

TocModal.defaultProps = {
  acceptTermsRequest: () => {},
  acceptPolicyError: false,
};

export default connect(
  state => state.areas.account.me,
  actions
)(memo(TocModal));
